export default __webpack_public_path__ + "icons_overall_height-bbB.svg";